import { Typography } from 'antd';
import ScrapInfoButton, { ScrapBreakdown } from './ScrapInfoButton';

const { Text } = Typography;

interface ScrapRecommendationProps {
	breakdown: ScrapBreakdown | null;
	/**
	 * Optional callback to copy the recommended value into the (editable)
	 * field. When provided a "Use" link is shown.
	 */
	onApply?: (value: number) => void;
}

/**
 * Compact, read-only recommendation shown under the editable scrap field. The
 * value is only a suggestion looked up from the volume/cost table; the user is
 * still responsible for setting the final scrap quantity in the input.
 */
const ScrapRecommendation = ({ breakdown, onApply }: ScrapRecommendationProps) => {
	if (!breakdown) return null;

	const value = breakdown.estimated_scrap_quantity;
	// PTB-5965: when earlier reservations for the same line item already took
	// part of the order's scrap allowance, the recommendation is the REMAINING
	// allowance. Surface that so a 0 recommendation reads as intentional.
	const alreadyAllocated = breakdown.already_allocated_scrap ?? 0;
	const allowance = breakdown.order_scrap_allowance;
	const showAllocation = alreadyAllocated > 0 && allowance != null;

	return (
		<div style={{ marginTop: 2, fontSize: 12, lineHeight: 1.4 }}>
			<Text type="secondary" style={{ fontSize: 12 }}>
				Recommended:{' '}
				<Text strong style={{ fontSize: 12 }}>
					{value}
				</Text>{' '}
				pcs
			</Text>
			{showAllocation && (
				<Text type="secondary" style={{ fontSize: 12 }}>
					{' '}
					(order allows {allowance}, {alreadyAllocated} already reserved)
				</Text>
			)}
			{onApply && (
				<>
					<Text type="secondary" style={{ fontSize: 12 }}>
						{' · '}
					</Text>
					<a
						style={{ fontSize: 12 }}
						onClick={(e) => {
							e.preventDefault();
							onApply(value);
						}}
					>
						Use
					</a>
				</>
			)}
			<ScrapInfoButton
				breakdown={breakdown}
				iconStyle={{ fontSize: 14, marginLeft: 6 }}
			/>
		</div>
	);
};

export default ScrapRecommendation;
